import fetch from 'cross-fetch'; // eslint-disable-line no-unused-vars
import { RSAA } from 'redux-api-middleware';
import Routes from '../utils/routes.js.erb';
import { tranformSuccessPayload, tranformEmptyPayload, transformBodyParams } from './transformers';
import { API_FAILURE, authHeaders } from './index';

export const CHAT_MESSAGE_BULK_SEND_REQUEST = 'CHAT_MESSAGE_BULK_SEND_REQUEST';
export const CHAT_MESSAGE_BULK_SEND_RECEIVE = 'CHAT_MESSAGE_BULK_SEND_RECEIVE';

export const sendMessages = (params, meta) => {
  return {
    [RSAA]: {
      endpoint: Routes.api_dashboard_bulk_messages_path(),
      headers: authHeaders(),
      method: 'POST',
      types: [CHAT_MESSAGE_BULK_SEND_REQUEST, tranformEmptyPayload(CHAT_MESSAGE_BULK_SEND_RECEIVE, meta), API_FAILURE],
      body: transformBodyParams(params),
      fetch: fetch,
    },
  };
}

export const bulkSend = (params, meta = {}) => {
  return sendMessages(params, meta);
}

export const CHAT_MESSAGE_BULK_SEND_FILTERS_REQUEST = 'CHAT_MESSAGE_BULK_SEND_FILTERS_REQUEST';
export const CHAT_MESSAGE_BULK_SEND_FILTERS_RECEIVE = 'CHAT_MESSAGE_BULK_SEND_FILTERS_RECEIVE';

export const fetchBulkSendFilters = (params, meta) => {
  return {
    [RSAA]: {
      endpoint: Routes.filters_api_dashboard_bulk_messages_path(params),
      headers: authHeaders(),
      method: 'GET',
      types: [CHAT_MESSAGE_BULK_SEND_FILTERS_REQUEST, tranformSuccessPayload(CHAT_MESSAGE_BULK_SEND_FILTERS_RECEIVE, meta), API_FAILURE],
      fetch: fetch,
    },
  };
}

export const loadBulkSendFilters = (params, meta = {}) => {
  return fetchBulkSendFilters(params, meta);
}

export const CHAT_MESSAGE_BULK_SEND_FILTERS_CLEAR = 'CHAT_MESSAGE_BULK_SEND_FILTERS_CLEAR';
export const clearBulkSendFilters = () => ({ type: CHAT_MESSAGE_BULK_SEND_FILTERS_CLEAR });
